import type { PortalStrings } from "./en";

export const zhHans: PortalStrings = {
  shell: {
    portal: "客户门户",
    nav: {
      home: "首页",
      case: "我的案件",
      caseShort: "案件",
      tasks: "任务",
      documents: "文件",
      profile: "我的资料",
      profileShort: "资料"
    },
    signOut: "退出登录",
    language: "语言",
    previewing:
      "您正在以 {{name}} 的视角查看其门户。仅供查看：此处不会保存或发送任何内容。",
    exitPreview: "退出预览",
    privacy: "只有您和您的法律团队可以查看您的信息。",
    notClient: "此账户未开通客户门户",
    notClientBody: "请联系您的法律团队邀请您，或使用收到邀请的邮箱登录。",
    useDifferentEmail: "使用其他邮箱",
    cantPreview: "无法预览此门户",
    loadFailed: "无法加载您的门户，请稍后再试。",
    retry: "重试"
  },
  greeting: {
    morning: "早上好，{{name}}",
    afternoon: "下午好，{{name}}",
    evening: "晚上好，{{name}}",
    withTasks_one: "这是我们需要您完成的事项。",
    withTasks_other: "以下是我们需要您完成的事项。",
    stageLine: {
      started: "您的案件正在启动。",
      gathering: "我们正在为您的案件收集信息。",
      review: "您的律师正在审核您的案件。",
      filed: "您的案件已提交给 USCIS。",
      decision: "您的案件已进入决定阶段。"
    },
    allCaughtUp: "目前没有待办事项。需要您提供信息时，我们会通知您。"
  },
  tasks: {
    title: "需要您完成的事项",
    count_one: "1 项任务",
    count_other: "{{count}} 项任务",
    none: "暂无任务",
    noneBody: "当您的法律团队需要您提供信息时，会显示在这里。",
    progress: "已回答 {{answered}}/{{total}}",
    minutesLeft_one: "大约还需 1 分钟",
    minutesLeft_other: "大约还需 {{count}} 分钟",
    due: "截止日期 {{date}}",
    dueToday: "今天截止",
    overdue: "已于 {{date}} 截止",
    changesRequested: "您的法律团队请您更新部分回答",
    start: "开始",
    continue: "继续",
    update: "更新回答",
    opening: "正在打开…",
    openFailed: "无法打开此任务。请使用邮件中的链接，或稍后再试。",
    previewOnly: "任务只能由客户本人打开。",
    sign: "查看并签署",
    ink: "开始",
    notYet: "暂未开放",
    signMeta: "约 {{minutes}} 分钟",
    inkMeta: "打印、用墨水签名、发送照片 · 约 {{minutes}} 分钟",
    upcoming: "准备好签署时开放",
    sendAgain: "您的律师团队请您重新发送"
  },
  case: {
    title: "您的案件",
    titlePlural: "您的案件",
    fullTimeline: "完整时间线",
    now: "当前进展",
    onHold: "您的案件目前暂停。恢复处理时，您的法律团队会通知您。",
    approved: "已批准",
    decision: "已作出决定",
    receipts: "USCIS 收据",
    noReceipts: "USCIS 寄出收据后，收据号码会显示在这里。",
    checkStatus: "查询 USCIS 状态",
    checking: "正在查询…",
    checkedAt: "查询于 {{when}}",
    statusFailed: "USCIS 暂时没有响应，请稍后再试。",
    details: "案件详情",
    caseType: "案件类型",
    opened: "立案日期",
    priorityDate: "优先日期",
    updates: "动态",
    noUpdates: "您的案件动态会显示在这里。",
    none: "暂无案件",
    noneBody: "您的法律团队为您立案后，您可以在这里跟进进展。",
    back: "全部案件",
    notFound: "找不到此案件。",
    step: "第 {{n}} 步，共 {{total}} 步",
    startedOn: "开始于 {{date}}",
    nowChip: "当前",
    waitingOnYou: "等待您处理",
    open: "打开",
    attorney: "律师",
    receiptNumber: "收据号码",
    receiptLater: "递交后显示在这里",
    priorityLater: "USCIS 收到后确定",
    questions: "对案件有疑问？",
    emailLead: "给 {{name}} 发邮件"
  },
  milestone: {
    rfe: "USCIS 要求补充证据（补件通知，RFE）。{{lead}} 正在准备回复，如需您提供材料会通知您。",
    interview:
      "USCIS 已安排面谈。{{lead}} 会帮助您准备，并告诉您需要携带什么。",
    biometrics:
      "USCIS 进入生物信息采集阶段：在 USCIS 办公室采集指纹和拍照。请携带预约通知和带照片的身份证件。"
  },
  stageAbout: {
    started: "您的法律团队为您立案，并确定需要您提供哪些信息。",
    gathering:
      "我们收集您的回答和文件：您的基本信息、个人经历，以及案件所需的证据。",
    review:
      "您的律师审核所有内容，准备表格和信函，并可能向您提出几个后续问题。",
    filed:
      "我们将您的案件递交给 USCIS。USCIS 寄出收据后，收据号码会显示在这里，您可以在此页面查询状态。",
    decision:
      "USCIS 批准案件、要求补充证据（补件通知）或拒绝。我们会向您说明接下来的安排。"
  },
  stage: {
    started: "准备开始",
    gathering: "收集信息",
    review: "律师审核",
    filed: "已递交 USCIS",
    decision: "审理结果"
  },
  explainer: {
    yourTeam: "您的法律团队",
    yourTeamLower: "您的法律团队",
    started:
      "{{lead}} 正在为您建立案件。我们需要您提供的所有内容都会显示在此页面上。",
    gathering:
      "{{lead}} 正在收集您的回答和文件。收齐后，{{leadFirst}} 会全面审核并开始准备您的申请材料。",
    review:
      "{{lead}} 正在审核您的信息并准备申请材料。您可能会收到几个后续问题。",
    filed:
      "您的案件已递交 USCIS。USCIS 通常会先邮寄收据通知，之后可能会安排生物信息采集预约。处理时间因案件类型而异。",
    decision:
      "USCIS 已对您的案件作出决定。{{lead}} 会向您解释其含义以及后续步骤。"
  },
  updates: {
    opened: "您的案件已立案",
    filed: "您的案件已递交 USCIS",
    approved: "USCIS 已批准您的案件",
    decided: "USCIS 已对您的案件作出决定",
    reopened: "您的案件已重新开启",
    receipt: "已添加 USCIS 收据 {{receipt}}",
    receipt_unnamed: "已添加一份 USCIS 收据",
    questions_sent: "我们向您发送了需要回答的问题",
    answers_received: "我们已收到您的回答",
    changes_requested: "我们请您更新部分回答",
    answers_reviewed: "您的回答已审核"
  },
  comingUp: {
    title: "即将到来",
    taskDue: "{{title}} 截止",
    allDay: "全天"
  },
  team: {
    title: "您的法律团队",
    email: "给 {{name}} 发邮件"
  },
  reminders: {
    title: "请留意",
    expiresIn_one: "{{subject}}明天到期",
    expiresIn_other: "{{subject}}将在 {{count}} 天后到期",
    expiresToday: "{{subject}}今天到期",
    expired: "记录中{{subject}}的到期日为 {{date}}",
    expiresHint: "续签或计划出行前，请先告知您的法律团队。",
    expiredHint: "如果您已收到更新的文件，请上传，以便您的法律团队存档。",
    yours: {
      status: "您的 {{status}} 身份",
      immigration_status_expiration: "您的移民身份",
      i94_expiration: "您的 I-94",
      passport_expiration: "您的护照",
      ead_expiration: "您的工作许可（EAD）",
      advance_parole_expiration: "您的回美证（advance parole）",
      visa_expiration: "您的签证"
    },
    theirs: {
      immigration_status_expiration: "{{name}}的移民身份",
      i94_expiration: "{{name}}的 I-94",
      passport_expiration: "{{name}}的护照",
      ead_expiration: "{{name}}的工作许可（EAD）",
      advance_parole_expiration: "{{name}}的回美证（advance parole）",
      visa_expiration: "{{name}}的签证"
    }
  },
  documents: {
    title: "文件",
    subtitle: "您发给我们的文件，以及您的法律团队与您共享的文件。",
    upload: "上传文件",
    takePhoto: "拍照",
    uploading: "正在上传 {{name}}…",
    uploaded: "{{name}} 已发送给您的法律团队",
    uploadFailed: "{{name}} 上传失败，请重试。",
    fromYou: "由您上传",
    fromTeam: "来自您的法律团队",
    open: "打开",
    remove: "删除",
    removed: "已删除 {{name}}",
    removeFailed: "删除失败，请重试。",
    none: "暂无文件",
    noneBody: "请上传您的法律团队要求的文件，或稍后查看他们与您共享的文件。",
    previewOnly: "预览模式下无法上传。",
    checking: "正在检查 {{name}}…",
    looksGood: "{{name}} 看起来没问题",
    weRead: "我们从中读到：",
    mayBeHard: "{{name}} 可能不够清晰",
    replace: "重新上传",
    keep: "保留"
  },
  sign: {
    from: "来自 {{name}}",
    inkWhy: "USCIS 要求纸质表格必须手写签名，所以这一页不能在屏幕上签署。",
    read: "阅读文件",
    readHint: "签署前请阅读每一页。",
    add: "添加您的签名",
    draw: "手写",
    type: "输入",
    drawHint: "用手指或鼠标在这里签名",
    clear: "清除",
    fullName: "您的全名",
    consent:
      "我同意以电子方式签署本文件，并同意我的电子签名与手写签名具有同等效力。",
    signAndSend: "签署并发送给 {{name}}",
    signing: "正在签署…",
    audit:
      "我们会把签署后的副本发到您的邮箱。您的签名、签署时间和文件指纹都会被记录，以便日后核实。",
    needSignature: "请先手写或输入您的签名。",
    needConsent: "请勾选同意以电子方式签署。",
    failed: "签署失败，请重试。",
    signed: "已签署",
    signedBody: "您已于 {{date}} 签署。副本已发送到您的邮箱。",
    signedNoCopy: "您已于 {{date}} 签署。",
    downloadSigned: "下载已签署的副本",
    print: "打印这一页",
    download: "下载需要签名的页面（PDF）",
    noPrinter: "没有打印机？请您的律师团队把它邮寄给您。",
    inkSign: "用黑色墨水签名",
    inkBox: "请在第 {{page}} 页标有“{{box}}”的方框内签名。",
    inkBoxPage: "请在第 {{page}} 页的签名框内签名。",
    photo: "给签好的页面拍照",
    photoHint: "把纸放平，光线充足，整页都要拍进去。",
    takePhoto: "拍照",
    chooseFile: "选择文件",
    retake: "重拍",
    checking: "正在检查您的照片…",
    found: "已在方框内找到签名",
    notFound: "我们没有在方框内看到签名",
    readable: "整页可见且清晰",
    notReadable: "页面部分内容不清晰",
    unchecked: "我们无法检查这张照片，但您仍然可以发送。",
    send: "发送给 {{name}}",
    sendAnyway: "仍然发送",
    sending: "正在发送…",
    uploadFailed: "照片没有上传成功，请重试。",
    keepOriginal: "请保留原件。{{name}} 可能会请您邮寄原件。",
    sent: "已发送给 {{name}}",
    sentBody: "{{name}} 会进行检查，如需其他材料会通知您。请保留原件。",
    completed: "已完成",
    completedBody: "{{name}} 已接受您签好的页面。",
    returned: "{{name}} 请您重新发送：",
    upcoming: "尚未准备好",
    upcomingBody: "准备好签署时，{{name}} 会通知您。",
    gone: "这份文件已不再需要您签署。",
    back: "返回任务",
    previewOnly: "预览模式下无法签署。",
    viewer: "待签署的文件",
    changed: "这份文件在发送后有改动。您的律师团队会重新发送。"
  },
  profile: {
    subtitle:
      "这些信息会填入您的移民表格。如有错误或变更，请提交更正建议，{{name}} 会进行审核。",
    about: "个人信息",
    contact: "联系方式",
    lived: "居住经历",
    worked: "工作经历",
    studied: "教育经历",
    noneOnFile: "暂无记录",
    notOnFile: "未记录",
    historyHint: "这里有遗漏或错误吗？",
    tellUs: "告诉 {{name}}",
    suggest: "提交更正",
    add: "添加",
    waiting: "等待 {{name}} 审核",
    withdraw: "撤回",
    withdrawn: "已撤回建议",
    updated: "已更新",
    kept: "{{name}} 保留了原有记录。",
    keptWhy: "{{name}} 保留了原有记录：{{reason}}",
    note: "有什么需要 {{name}} 了解的吗？",
    notePlaceholder: "例如：我的护照上的拼写是正确的。",
    addressPlaceholder: "如果您搬家了，请告诉我们时间。",
    historyLabel: "遗漏或错误的内容是什么？",
    historyPlaceholder:
      "例如：2019 年 6 月至 2020 年 5 月，我住在 12 Elm St, Austin, TX。",
    yourNotes: "您发送的说明",
    attach: "附加文件",
    attachHint: "能证明正确信息的照片或 PDF。",
    attaching: "正在上传 {{name}}…",
    attachFailed: "文件上传失败，请重试。",
    removeAttachment: "移除附件",
    cancel: "取消",
    send: "发送给 {{name}}",
    sending: "正在发送…",
    sent: "已发送给 {{name}} 审核",
    failed: "发送失败，请重试。",
    unchanged: "这与现有记录一致。请先修改内容。",
    previewOnly: "预览模式下无法提交建议。",
    present: "至今",
    topic: {
      legal_name: "法定姓名",
      other_names: "曾用名",
      birthday: "出生日期",
      birthplace: "出生地",
      citizenships: "国籍",
      marital_status: "婚姻状况",
      email: "邮箱",
      phone: "电话",
      physical_address: "住址",
      mailing_address: "邮寄地址",
      history: "您的经历"
    },
    field: {
      first_name: "名",
      middle_name: "中间名",
      last_name: "姓",
      other_names: "曾用名（用逗号分隔）",
      birthday: "出生日期",
      city_of_birth: "城市",
      state_of_birth: "省/州",
      country_of_birth: "国家",
      citizenships: "国家（用逗号分隔）",
      marital_status: "婚姻状况",
      email: "邮箱",
      phone: "电话",
      street: "街道和门牌号",
      city: "城市",
      state: "州",
      zip_code: "邮政编码",
      country: "国家"
    },
    marital: {
      single: "单身，从未结婚",
      married: "已婚",
      divorced: "离婚",
      widowed: "丧偶",
      separated: "合法分居",
      annulled: "婚姻已宣告无效"
    }
  },
  signIn: {
    title: "登录您的门户",
    sentTitle: "请查看您的邮箱",
    email: "邮箱",
    send: "通过邮件发送登录链接",
    sending: "正在发送…",
    hint: "无需密码。我们会向此邮箱发送一个登录链接。",
    sent: "如果 {{email}} 已开通客户门户，登录链接已发送。该链接只能使用一次，一小时后失效。",
    sendAnother: "使用其他邮箱",
    failed: "链接发送失败，请一分钟后再试。",
    staff: "您在律师事务所工作？",
    staffLink: "在此登录"
  },
  welcome: {
    signingIn: "正在登录…",
    expired: "此链接已失效",
    used: "此链接已被使用",
    invalid: "此链接无效",
    revoked: "此链接已停用",
    off: "门户访问已关闭",
    offBody: "请联系您的法律团队重新开启。",
    getNew: "输入您的邮箱，我们会发送新的登录链接。"
  },
  intake: {
    language: "语言",
    showEnglish: "显示英文",
    showTranslated: "显示{{language}}",
    translating: "正在翻译问题…",
    translationFailed: "暂时无法翻译问题，以下显示英文原文。",
    answerHint:
      "如有可能，请用英文回答。如果不方便，也可以用您的母语回答，您的法律团队会进行翻译。",
    defaultNote: "请慢慢填写此问卷，并确保所有信息与您的正式证件一致。",
    defaultTitle: "移民客户问卷",
    start: "开始",
    resume: "继续",
    fix_one: "修改 {{count}} 个回答 →",
    fix_other: "修改 {{count}} 个回答 →",
    takes_one: "大约需要 {{count}} 分钟",
    takes_other: "大约需要 {{count}} 分钟",
    left_one: "大约还需 {{count}} 分钟",
    left_other: "大约还需 {{count}} 分钟",
    about_one: "大约 {{count}} 分钟",
    about_other: "大约 {{count}} 分钟",
    othersSaved_one: " · 另 1 个回答已保存",
    othersSaved_other: " · 另 {{count}} 个回答已保存",
    needsChanges_one: "您的律师已审核您的回答，需要修改 1 处。",
    needsChanges_other: "您的律师已审核您的回答，需要修改 {{count}} 处。",
    attorney: "律师",
    yourAttorney: "您的律师",
    yourAttorneyLower: "您的律师",
    yourFirm: "您的律师事务所",
    you: "您",
    welcomeBack: "欢迎回来",
    welcomeBackName: "欢迎回来，{{name}}。",
    resumeBody: "您已开始填写此问卷。要从上次离开的地方继续吗？",
    continueWhereLeft: "从上次离开的地方继续",
    reviewFromStart: "从头查看",
    ok: "确定",
    skip: "跳过",
    continue: "继续",
    submit: "提交",
    sendTo: "发送给 {{name}}",
    yes: "是",
    no: "否",
    previousStep: "上一步",
    nextStep: "下一步",
    displaySettings: "显示设置",
    typeAnswer: "在此输入您的回答...",
    yourAnswer: "您的回答",
    typeOrSelect: "输入或选择一个选项",
    noMatches: "没有匹配的选项",
    street: "街道地址",
    city: "城市",
    state: "州/省",
    statePlaceholder: "州",
    postal: "邮政编码",
    postalPlaceholder: "邮政编码",
    country: "国家",
    dragDrop: "将文件拖放到此处",
    uploadingShort: "正在上传...",
    upload: "上传",
    uploadMore: "继续上传",
    uploadedFiles: "已上传的文件",
    uploadingDocument: "正在上传文件",
    uploaded: "已上传",
    uploadedBody_one: "您的文件已成功上传。",
    uploadedBody_other: "已成功上传 {{count}} 个文件。",
    someFailed: "部分文件上传失败",
    uploadFailed: "上传失败",
    pleaseTryAgain: "请重试。",
    saved: "已保存",
    savedBody: "您可以关闭此页面，之后用同一链接回来继续。",
    couldntSave: "无法保存",
    submitted: "已提交",
    submittedBody: "您的回答已成功提交。",
    couldntSubmit: "无法提交",
    thankYou: "谢谢！",
    thankYouBody:
      "您的法律团队已收到您的回答，很快会进行审核。您现在可以关闭此页面。",
    review: "核对您的回答",
    reviewBody: "提交前请核对您的回答。如需修改，可以直接编辑。",
    reviewGroupBody: "您可以编辑或删除任意条目，也可以再添加一条。",
    edit: "编辑",
    remove: "删除",
    notAnswered: "未回答",
    notProvided: "未提供",
    noEntries: "暂无条目。",
    noEntriesAdded: "未添加任何条目。",
    noEntriesYet: "尚未添加条目。",
    noEntriesSubmitted: "未提交任何条目。",
    noDetails: "尚未提供详细信息。",
    noDocChanges: "没有需要修改的文件。",
    noDocs: "暂无文件。",
    leaveComment: "留言...",
    addComment: "添加留言",
    addReply: "回复",
    cancel: "取消",
    youSent: "您发送了",
    youAnswered: "您的回答：",
    addAnother: "再添加一条？",
    loadFailed: "问卷加载失败",
    oops: "抱歉，出了点问题。",
    persists: "如果问题仍然存在，请联系您的律师事务所。",
    tryAgain: "重试",
    attention_one: "有 1 个文件需要处理",
    attention_other: "有 {{count}} 个文件需要处理",
    attentionBody: "您的律师可能会请您重新发送这些文件。",
    sendAnyway: "仍然发送",
    savesAuto: "您的进度会自动保存",
    prefilledCount_one: "已填好 {{count}} 个答案",
    prefilledCount_other: "已填好 {{count}} 个答案",
    progressOf: "第 {{current}} 题，共 {{total}} 题",
    savedAt: "已保存 {{time}}",
    backToPortal: "返回您的门户",
    outline: {
      questions_one: "{{count}} 个问题",
      questions_other: "{{count}} 个问题",
      filled_one: "已填 {{count}} 个",
      filled_other: "已填 {{count}} 个",
      minutes_one: "{{count}} 分钟",
      minutes_other: "{{count}} 分钟",
      done: "已完成"
    },
    prefill: {
      ask: "这是否正确？",
      yes: "是的，正确",
      change: "修改",
      fromDocs: "来自您的文件",
      onFile: "我们已有记录"
    },
    date: {
      day: "日",
      month: "月",
      year: "年",
      pickMonth: "选择月份",
      echo: "您填写的是：{{date}}",
      invalid: "这个日期不存在，请检查日和月。"
    },
    ph: {
      email: "name@example.com",
      phone: "+1 555 123 4567",
      givenName: "与护照上一致",
      familyName: "与护照上一致",
      middleName: "如果没有，请留空",
      otherNames: "您用过的其他姓名",
      fullName: "全名",
      number: "与文件上印的一致",
      city: "城市",
      country: "国家",
      employer: "公司或机构",
      jobTitle: "您的职位",
      school: "学校或大学",
      website: "https://",
      longText: "在此输入您的回答…",
      answer: "在此输入您的回答…"
    },
    group: {
      tellUs: "请告诉我们您的{{name}}。",
      tellUsAddresses: "请告诉我们您的居住经历。",
      tellUsEmployment: "请告诉我们您的工作经历。",
      tellUsStatuses: "请告诉我们您的移民身份经历。",
      tellUsTrips: "请告诉我们您出入美国的记录。",
      tellUsDependents: "请告诉我们您的家属信息。",
      leadIn: "您有需要添加的{{name}}吗？",
      leadInAddresses: "您有以前的住址需要添加吗？",
      leadInEmployment: "您有工作经历需要添加吗？",
      leadInStatuses: "您有移民身份经历需要添加吗？",
      leadInTrips: "您有出入美国的记录需要添加吗？",
      addAnother: "再添加一条{{name}}？",
      addAnotherAddress: "再添加一个住址？",
      addAnotherEmployer: "再添加一个雇主？",
      addAnotherStatus: "再添加一个身份？",
      addAnotherTrip: "再添加一次行程？",
      review: "核对您的{{name}}",
      reviewAddresses: "核对您的住址",
      reviewEmployers: "核对您的雇主",
      reviewStatuses: "核对您的身份",
      reviewTrips: "核对您的行程",
      entries: "条目"
    }
  },
  common: {
    loading: "正在加载…",
    today: "今天",
    yesterday: "昨天",
    daysAgo_one: "1 天前",
    daysAgo_other: "{{count}} 天前"
  }
};
